import { render, staticRenderFns } from "./AccessLightList.vue?vue&type=template&id=13cafced&"
import script from "./AccessLightList.vue?vue&type=script&lang=js&"
export * from "./AccessLightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports